import { SlidersHorizontal, RotateCcw, RefreshCw } from "lucide-react";
import type { ReactNode } from "react";

import { DateInput } from "@/components/ui/DateInput";

import { Button } from "@/components/ui/Button";

import { cn } from "@/utils/cn";



export interface DateFilterValues {

  startDate: string;

  endDate: string;

}



interface DateFilterBarProps {

  values: DateFilterValues;

  onChange: (values: DateFilterValues) => void;

  onApply: () => void;

  onReset?: () => void;

  loading?: boolean;

  className?: string;

  minStartDate?: string;

  extraActions?: ReactNode;

}



export function DateFilterBar({

  values,

  onChange,

  onApply,

  onReset,

  loading = false,

  className,

  minStartDate,

  extraActions,

}: DateFilterBarProps) {

  const setField = (field: keyof DateFilterValues) => (val: string) =>

    onChange({ ...values, [field]: val });



  const handleKeyDown = (e: React.KeyboardEvent) => {

    if (e.key === "Enter") onApply();

  };



  return (

    <div

      className={cn(

        "bg-white rounded-xl border border-slate-200 shadow-card px-5 py-4",

        className,

      )}

      onKeyDown={handleKeyDown}

    >

      <div className="mb-3 flex flex-wrap items-center gap-2">

        <SlidersHorizontal className="h-3.5 w-3.5 flex-shrink-0 text-brand-600" />

        <span className="text-xs font-semibold uppercase tracking-wider text-slate-500">Período</span>
      </div>



      <div className="flex flex-wrap items-end gap-2 sm:gap-3">

        <div className="min-w-[140px] max-w-[180px] flex-1">

          <DateInput

            label="Data Inicial"

            value={values.startDate}

            onChange={setField("startDate")}

            min={minStartDate}

            max={values.endDate || undefined}

          />

        </div>

        <div className="min-w-[140px] max-w-[180px] flex-1">

          <DateInput

            label="Data Final"

            value={values.endDate}

            onChange={setField("endDate")}

            min={values.startDate || undefined}

          />

        </div>

        <div className="ml-auto flex flex-shrink-0 items-end gap-2 self-end">

          {extraActions}

          <Button

            variant="primary"

            size="md"

            onClick={onApply}

            loading={loading}

            leftIcon={<RefreshCw className="h-4 w-4" />}

          >

            Atualizar

          </Button>

          {onReset && (

            <Button variant="ghost" size="md" onClick={onReset} title="Últimos 30 dias">

              <RotateCcw className="h-4 w-4" />

            </Button>

          )}

        </div>

      </div>

    </div>

  );

}

